import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleFilled,
  PlusOutlined,
  SearchOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { Col, Row, Space, Input, Switch, Popover } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/manage-user/actions'
import { getUserStatus } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { StaffStatus } from 'helpers/constanst'
import { ConfirmDailog } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import UserDetail from './UserDetail'
import ResetPin from './ResetPin'
import theme from 'Components/common/Theme'
import { deleteUserAPI, merchantRoleAPI, updateUserStatusAPI, userListAPI } from 'Store/manage-user/api'
import { MerchantRoles, UserData, UserListReq, UserStatusReq, DeleteUserReq } from 'Store/manage-user/types'
import { selectUserList, selectRoleList, selectActionEvent } from 'Store/manage-user/selector'

type Props = {} & ReduxProps

const UserList: React.FunctionComponent<Props> = props => {
  const { currentUser, staffList, roles, actionEvent } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [resetPindrawer, setResetPindrawer] = useState(false)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted' | 'update-status')

  const [filter, setFilter] = useState({
    keyword: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = staffList.meta
  const datas = staffList.data
  const event = staffList.event

  const onGetStaffList = (): void => {
    const req: UserListReq = {
      per_page: pagination.RowPerPage,
      page: pagination.Page,
      username: filter.keyword,
    }
    dispatch(userListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onGetStaffRoles = (): void => {
    dispatch(merchantRoleAPI({}, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onDeleteStaff = (id: number): void => {
    const req: DeleteUserReq = {
      id,
    }
    dispatch(deleteUserAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onUpdateStatusStaff = (id: number): void => {
    const req: UserStatusReq = {
      id,
    }
    dispatch(updateUserStatusAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetStaffList()
    }
  }, [pagination])

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetStaffRoles()
    }
  }, [])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
    setResetPindrawer(false)
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onClickUpdateStatus = (id: number) => {
    setPageMode('update-status')
    setSelectedID(id)
    onUpdateStatusStaff(id)
  }

  const onClickReset = (id: number) => {
    setSelectedID(id)
    setResetPindrawer(true)
  }

  const onConfirmDelete = () => {
    onDeleteStaff(selectedID)
    onCloseConfirmDelete()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetStaffList()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onUpdateSuccess = (): void => {
    clearEvent()
    onGetStaffList()
  }

  const renderUserStatus = (status: StaffStatus) => (
    <StatusTag isPass={status === StaffStatus.ACTIVE} text={getUserStatus(status)} />
  )

  const renderSwitchStatus = (status: string, record: any) => {
    const isActive = status === 'active'
    const isOwner = record.type === 'owner'
    return (
      <Switch
        loading={actionEvent.IsLoading}
        checked={isActive}
        onChange={() => onClickUpdateStatus(record.id)}
        disabled={isOwner}
      />
    )
  }

  const popOverContent = (role_names: string[]) => {
    if (role_names.length <= 0) {
      return 'ยังไม่ระบุสิทธิ์การใช้งาน'
    }
    return role_names.map((item, index) => {
      return <MerchantName key={index}>{item}</MerchantName>
    })
  }

  const renderRoles = (roles: MerchantRoles[], record: UserData) => {
    if (roles.length === 0) {
      return '-'
    }
    return (
      <Space direction="vertical">
        {record.merchant_roles.map((item, index) => {
          return (
            <Space key={index}>
              <MerchantName>{item.name}</MerchantName>
              <Popover content={popOverContent(item.role_names)} trigger="hover" placement="right">
                <InfoCircleFilled style={{ color: theme.colors.grey }} />
              </Popover>
            </Space>
          )
        })}
      </Space>
    )
  }

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<EditOutlined />}
        label="รีเซ็ตรหัสผ่าน"
        action="success"
        onClick={() => onClickReset(record.id)}
      />
      {record?.type !== 'owner' && (
        <ActionButton
          text=""
          icon={<SettingOutlined />}
          label="จัดการสิทธิ์"
          action="edit"
          onClick={() => onClickEdit(record.id)}
        />
      )}
      {record?.type !== 'owner' && (
        <ActionButton
          text=""
          icon={<DeleteOutlined />}
          label="ลบผู้ใช้"
          action="deleted"
          onClick={() => onClickDelete(record.id)}
        />
      )}
    </Space>
  )

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'ชื่อผู้ใช้งาน',
      dataIndex: 'username',
      key: 'username',
      width: '200px',
    },
    // {
    //   title: 'สิทธิ์การใช้งาน',
    //   dataIndex: 'package_roles',
    //   key: 'package_roles',
    //   render: renderRoles,
    // },
    {
      title: 'ใช้งานกับร้านค้า',
      dataIndex: 'merchant_roles',
      key: 'merchant_roles',
      render: renderRoles,
    },
    {
      title: 'เปิด/ปิดสถานะ',
      key: 'status',
      dataIndex: 'status',
      render: renderSwitchStatus,
      width: '120px',
    },
    {
      title: 'สถานะการเข้าใช้งาน',
      key: 'status',
      dataIndex: 'status',
      render: renderUserStatus,
    },
    {
      title: 'รีเซ็ตรหัสผ่าน/จัดการสิทธิ์/ลบ',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const DetailDrawer = (
    <UserDetail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
      roles={roles.data}
    />
  )

  const ResetPinDrawer = (
    <ResetPin id={selectedID} visible={resetPindrawer} onCloseDrawer={onCloseDrawer} onSuccess={onSuccess} />
  )

  const LoadingModal = (
    <EventModal
      event={[actionEvent]}
      enable={pageMode === 'deleted' || pageMode === 'update-status'}
      successCalback={onUpdateSuccess}
      errorCalback={clearEvent}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={12}>
          <Space size="middle" align="end">
            <SearchInput
              placeholder="ค้นหาชื่อผู้ใช้งาน"
              prefix={<SearchOutlined />}
              allowClear
              value={filter.keyword}
              onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
            />
            <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
          </Space>
        </MyCol>
        <MyCol>
          <Space size="middle">
            <PrimaryButton text="เพิ่มผู้ใช้งาน" icon={<PlusOutlined />} onClick={onClickCreate} />
          </Space>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      {FilterContent}
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={event.IsLoading}
        paginationContent={PaginationContent}
        scrollX={600}
      />
      {LoadingModal}
      {DetailDrawer}
      {ResetPinDrawer}
      {ConfirmDeleteModal}
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    staffList: selectUserList(state),
    roles: selectRoleList(state),
    actionEvent: selectActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const MerchantName = styled.div``

export default connect(mapStateToProps)(UserList)
